var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { Popup } from '@progress/kendo-react-popup';
/**
 * @hidden
 */

var ColumnMenu = function (_super) {
  __extends(ColumnMenu, _super);

  function ColumnMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      show: false
    };
    _this.blurTimeout = undefined;

    _this.blur = function () {
      clearTimeout(_this.blurTimeout);
      _this.blurTimeout = setTimeout(function () {
        _this.closeMenu();
      });
    };

    _this.focus = function () {
      clearTimeout(_this.blurTimeout);
    };

    _this.anchorClick = function () {
      _this.setState({
        show: !_this.state.show
      }, function () {
        return _this.state.show && _this._content && _this._content.focus();
      });
    };

    _this.closeMenu = function () {
      _this.setState({
        show: false
      });
    };

    return _this;
  }

  ColumnMenu.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        ChildComponent = _a.render,
        others = __rest(_a, ["render"]);

    return React.createElement("div", {
      style: {
        display: 'inline'
      }
    }, React.createElement("div", {
      style: {
        display: 'inline',
        position: 'absolute',
        cursor: 'pointer',
        right: 5
      },
      ref: function ref(e) {
        return _this._anchor = e;
      },
      onClick: this.anchorClick
    }, React.createElement("span", {
      className: 'k-icon k-i-more-vertical'
    })), React.createElement(Popup, {
      anchor: this._anchor,
      show: this.state.show
    }, React.createElement("div", {
      ref: function ref(e) {
        return _this._content = e;
      },
      className: 'k-grid-columnmenu-popup',
      tabIndex: 0,
      onBlur: this.blur,
      onFocus: this.focus,
      style: {
        outline: 'none'
      }
    }, React.createElement(ChildComponent, __assign({}, others, {
      onCloseMenu: this.closeMenu
    })))));
  };

  return ColumnMenu;
}(React.Component);

export { ColumnMenu };